module.exports = __webpack_public_path__ + "videos/wallet.6039d1f.webm";